<template>
  <div class="about-page">
    <TopBanner />
    <div class="about-scroll-area">
      <div class="about-box">
        <div class="about-title">平台简介</div>
        <div class="about-content">
          <div class="agreement-content" v-html="content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBanner from "@/components/TopBanner.vue";
import { queryConfig } from "@/api/config";

export default {
  name: "About",
  components: {
    TopBanner,
  },
  data() {
    return {
      content: "",
    };
  },
  created() {
    this.fetchPrivacyPolicy();
  },
  methods: {
    async fetchPrivacyPolicy() {
      try {
        const res = await queryConfig({
          businessKey: "",
          configKeyList: ["about_us_introduce"],
        });
        // 假设返回的数据结构为 { code, data, message }
        // data 为配置列表，取第一条记录的 content/value 字段
        if (res && res.data) {
          const configData = Array.isArray(res.data) ? res.data : [res.data];
          if (configData.length > 0) {
            // 根据实际返回字段取内容：优先取 configValue / content / value
            this.content = configData[0].configValue || configData[0].content || configData[0].value || "";
          }
        }
      } catch (error) {
        console.error("获取隐私协议失败：", error);
      }
    },
  },
};
</script>

<style scoped>
.about-page {
  height: 100vh;
  overflow: hidden;
  background: #f0f4fa;
}

.about-scroll-area {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.about-box {
  border-radius: 20px;
  width: 1200px;
  background: #fff;
  margin: 16px auto 0 auto;
  padding: 20px 17px 52px 17px;
}

.about-content {
  margin-top: 10px;
}

.about-title {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 28px;
  color: #333333;
}
</style>
